export default {
  vidFleet_video_player_wakingCamera: 'Estableciando conexión con la cámara...',
  vidFleet_video_player_stopingCamera: 'Finalizando transmisión en vivo...',
  vidFleet_video_player_stoppedCamera: 'Transmisión finalizada',
  vidFleet_video_player_errorApi: 'No se pudo cargar el video debido a un error en la API de VidFleet, por favor intente de nuevo.',
  vidFleet_video_player_retryMessage: 'El video no se pudo cargar, ya sea porque el servidor o la red fallaron, por favor intente de nuevo.',
  vidFleet_video_player_cameraOffline: 'La cámara está desconectada',
  vidFleet_video_player_360Message: 'Utilice el mouse para arrastrar y soltar el video',
  vidFleet_errorAccessDenied: 'No se pudo cargar el video, acceso denegado',
  vidFleet_timeout: "Se agotó el tiempo de espera del video en vivo.",
  vidFleet_clip_details: 'Detalles del Clip',
}